import { SET_CAP_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const capUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CAP_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default capUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/CAP/reducer.js